function getHeight(elm: HTMLElement) {
	let val: number = 0;

	if (elm.offsetParent === null) { // not visible
		throw new Error("Invisible Element - can't get height");
	}

	if (elm.scrollHeight) {
		elm.style.height = "1px";
		elm.style.overflow = "hidden";
		val = elm.scrollHeight + 20; // 25 prevents a scroll bar from showing up
	} else {
		val = elm.clientHeight || parseInt(elm.style.height || "0", 10);
	}

	return val;
}

function maxHeight(elements: HTMLElement[]): number {
	return elements.reduce((previousValue: number, elm: HTMLElement): number => {
		return Math.max(previousValue, getHeight(elm));
	}, 0);
}

export class GroupHeightMaintainer {

	private timeout: number | null = null;

	constructor(private elements: HTMLElement[]) {
		const updateEvent = () => this.updateEvent();
		for (const elm of elements) {
			const initInterval = window.setInterval(() => {
				if (elm.offsetParent !== null) { // wait for element to become visible
					this.maintainHeight();
					window.clearInterval(initInterval);
				}
			}, 300);

			elm.addEventListener("change", updateEvent);
			elm.addEventListener("keyup", updateEvent);
			elm.addEventListener("input", updateEvent);
		}
	}

	public updateEvent() {
		if (this.timeout !== null) {
			window.clearTimeout(this.timeout);
		}

		this.timeout = window.setTimeout(() => this.maintainHeight(), 50);
	}

	public maintainHeight() {
		const windowTop = window.scrollY || window.pageYOffset;  // needs to come before calls to getHeight
		const height = maxHeight(this.elements);

		for (const elm of this.elements) {
			if ((parseInt(elm.style.height || "0", 10)) != height) {
				elm.style.height = height + "px";
			}
		}

		window.scrollTo(0, windowTop);
	}

	public static initGroupedByAttributeValue(root: HTMLElement = document.body, groupAttribute: string = "data-height-group"): GroupHeightMaintainer[] {
		const byGroup: Record<string, HTMLElement[]> = { };
		const elements = Array.from(root.querySelectorAll(`[${groupAttribute}]`));
		elements.forEach(e => {
			const group = e.getAttribute(groupAttribute);
			e.removeAttribute(groupAttribute);
			if (! (e instanceof HTMLElement) || group === null) {
				return;
			}
			if (!(group in byGroup)) {
				byGroup[group] = [];
			}
			byGroup[group].push(e);
		});
		return Object.values(byGroup).map(elements => new GroupHeightMaintainer(elements));
	}
}
